// Vue Router runs in hash mode (#/...). Normalize any outer path/search the
// browser may carry (from a server-side fallback or an earlier write to
// window.location) into the hash, so the address bar doesn't accumulate
// duplicate query params or stale paths.
(function normalizeHashRoute() {
  const path = window.location.pathname;
  const search = window.location.search;
  const hash = window.location.hash;
  if ((!path || path === '/') && !search) return;

  if (hash && hash.length > 1) {
    // Hash already carries the real route — drop the outer path and search.
    window.history.replaceState(null, '', `/${hash}`);
  } else {
    // Synthesize a hash route from the outer path + search.
    const cleanPath = path.replace(/\/+$/, '') || '/';
    window.history.replaceState(null, '', `/#${cleanPath}${search}`);
  }
})();

import Vue from 'vue'
import App from './App.vue'
import vuetify from './plugins/vuetify'
import store from './store';
import router from './router';
import i18n from './plugins/i18n.js';
import axios from 'axios';
import linkify from './directives/linkify';

Vue.directive('linkify', linkify);

import ValidationPlugin from "@/plugins/validation.plugin";
import GoogleAnalyticsEventsHelper from '@/plugins/google-analytics-events-helper';

Vue.config.productionTip = false

Vue.use(ValidationPlugin);
Vue.use(GoogleAnalyticsEventsHelper);

if (process.env.VUE_APP_BASE_URL) {
  axios.defaults.baseURL = process.env.VUE_APP_BASE_URL.trim();
}

new Vue({
  vuetify,
  store,
  router,
  i18n,
  render: h => h(App)
}).$mount('#app')
